import { render, staticRenderFns } from "./Nomore.vue?vue&type=template&id=01495416&scoped=true"
var script = {}
import style0 from "./Nomore.vue?vue&type=style&index=0&id=01495416&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01495416",
  null
  
)

export default component.exports